export function formatSubmissionDate(value: string, month: 'numeric' | 'short' = 'numeric'): string {
  if (!value) return 'Not available';
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
  const date = new Date(dateOnly ? `${value}T00:00:00` : value);
  if (Number.isNaN(date.getTime())) return 'Not available';
  // Older API responses contain only a date; do not invent a submission time.
  return date.toLocaleString('en-US', {
    year: 'numeric', month, day: 'numeric',
    ...(!dateOnly && { hour: 'numeric', minute: '2-digit', second: '2-digit' }),
  });
}
